import { environment } from '../../../environments/environment';
import { ICustomers } from '../../interfaces/ICustomers';
import { IRegion } from '../../interfaces/IFilters';
import { ColumnDataType, ITableMatcher } from '../../interfaces/ITable';

export const ELASTIC_APM_SERVICENAME = 'one-customer-EnterpriseDataEntry';
export const ECOLAB_LOGO = 'assets/images/ecolab.svg';
export const USER_LAYOUT_LOGO = 'assets/images/user-layout.svg';

export const LOG_OUT = 'Log Out';
export const DROPDOWNOPTIONS = ['Log Out'];
export const UI_CONTROL_DEFAULT_VALUE_ALL = 'All';
export const BIC_DEFAULT_FILTERS = ['test1', 'test2', 'test3'];
export const INDUSTRY_SEGMENT = 'Industry Segment';
export const MARKET = 'Market';
export const SUBMARKET = 'Sub Market';
export const CUSTOMER = 'Customer';
export const REGION = 'Region';
export const COUNTRY = 'Country';
export const STATE = 'State/Province';
export const CLEAR_FILTERS = 'Clear filters';
export const ADD_NEW = 'Add new';
export const ALL = 'All';
export const ARE_YOU_SURE_TEXT = 'Are you sure?';
export const DELETE = 'Delete';
export const CANCEL = 'Cancel';
export const CLOSE = 'close';
export const WARNING_TEXT = 'This action cannot be undone.';
export const WARNING_DESCRIPTION =
  'All values associated with this record will be deleted.';
// Customer site profile
export const ECOLABSITEID = 'Ecolab Site Id';
export const CUSTOMERSITEID = 'Customer Site Id';
export const SITEADDRESS = 'Site Address';
export const SITEDESCRIPTION = 'Site Description';
export const ADD_SITE_PROFILE = 'Add New Site Profile';
export const VIEW_SITE_PROFILE = 'Edit Site Profile';
export const DEFAULT_ALL = 'ALL';
export const OFFERING = 'Offering Name';
export const CUSTOMERSITE = 'Customer Site';
export const DIVISION = 'Division';

export enum YesNoOption {
  YES = 'Yes',
  NO = 'No',
}

export enum IconCollection {
  FORM_ERROR_ICON = 'assets/images/error-icon.svg',
  DEFAULT_ICON = 'assets/images/default.png',
  ERROR_ICON = 'assets/images/error.png',
  WARNING_ICON = 'assets/images/warning.png',
  SUCCESS_ICON = 'assets/images/success.png',
  CARD_DELETE_ICON = 'assets/images/card-delete-icon.svg',
  ADD_ATTRI_ICON = 'assets/images/add-attribute-icon.svg',
  OPEN_ACCORDION_ICON = 'assets/images/open-caret.svg',
  CLOSE_ACCORDION_ICON = 'assets/images/close-caret.svg',
}

export enum Message {
  DEFAULT = 'default',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
}

export const DEFAULT_SITE_PROFILES_TABLE_MAPPER: ITableMatcher[] = [
  {
    fieldName: 'industrySegment',
    displayColumn: 'Industry Segment',
    dataTypeColumn: ColumnDataType.Text,
    filterName: 'filterIndustrySegment',
  },
  {
    fieldName: 'market',
    displayColumn: 'Market',
    dataTypeColumn: ColumnDataType.Text,
    filterName: 'filterMarket',
  },
  {
    fieldName: 'submarket',
    displayColumn: 'Sub Market',
    dataTypeColumn: ColumnDataType.Text,
    filterName: 'filterSubmarket',
  },
  {
    fieldName: 'customer',
    displayColumn: 'Customer',
    dataTypeColumn: ColumnDataType.Text,
    filterName: 'filterCustomer',
  },
  {
    fieldName: 'region',
    displayColumn: 'Region',
    dataTypeColumn: ColumnDataType.Text,
    filterName: 'filterRegion',
  },
  {
    fieldName: 'country',
    displayColumn: 'Country',
    dataTypeColumn: ColumnDataType.Text,
    filterName: 'filterCountry',
  },
  {
    fieldName: 'custom',
    displayColumn: '',
    dataTypeColumn: ColumnDataType.Custom,
    filterName: 'customFilter',
  },
];
export const BIC_MODULE_NAME = 'BIC';
export const BIC_FEATURE_NAME = 'Default Site Profile';
export const BIC_CUSTOMER_SITE_PROFILE = 'Customer Site Profile';
export const BIC_OFFERING_POTENTIAL_INVESTMENT =
  'Offering Potential and Investment';
export const ADMIN_CUSTOMER_SITE_MANAGER = 'Customer Site Manager';
export const BIC_FEATURE_DESCRIPTION = `The purpose of this page is to set and maintain assumptions for key site
      characteristics and customer assets based on industry segmentation,
      customer identity, or geography.`;
export const BIC_CUSTOMER_SITE_PROFILE_FEATURE_DESCRIPTION = `The purpose of this page is to set and maintain key site characteristics and customer assets for customer sites.`;

export const BIC_OFFERING_POTENTIAL_INVESTMENT_FEATURE_DESCRIPTION = `The purpose of this page is to set and maintain the BIC potential, Ecolab investment, and scaling for BIC Offerings, based on projects or products.`;
export const BIC_CUSTOMER_SITE_MANAGER_FEATURE_DESCRIPTION = `The purpose of this page is to maintain preferences for customer sites to be included or excluded from Best-in-Class.`;
export const CUSTOMER_TABLE_MAPPER: ITableMatcher[] = [
  {
    fieldName: 'customer',
    displayColumn: 'Customer',
    dataTypeColumn: ColumnDataType.Text,
    sticky: true,
    filterName: 'filterCustomer',
  },
  {
    fieldName: 'ecolabSiteId',
    displayColumn: 'Ecolab Site ID',
    dataTypeColumn: ColumnDataType.Text,
    sticky: true,
    filterName: 'filterEcolabSiteId',
  },
  {
    fieldName: 'customerPropertyCd',
    displayColumn: 'Customer Site ID',
    dataTypeColumn: ColumnDataType.Text,
    filterName: 'filterCustomerPropertyCd',
  },
  {
    fieldName: 'siteAddress',
    displayColumn: 'Site Address',
    dataTypeColumn: ColumnDataType.Text,
    filterName: 'filterSiteAddress',
  },
  {
    fieldName: 'country',
    displayColumn: 'Country',
    dataTypeColumn: ColumnDataType.Text,
    filterName: 'filterCountry',
  },
  {
    fieldName: 'siteDescription',
    displayColumn: 'Site Description',
    dataTypeColumn: ColumnDataType.Text,
    filterName: 'filterSiteDescription',
  },
  {
    fieldName: 'industrySegment',
    displayColumn: 'Industry Segment',
    dataTypeColumn: ColumnDataType.Text,
    filterName: 'filterIndustrySegment',
  },
  {
    fieldName: 'market',
    displayColumn: 'Market',
    dataTypeColumn: ColumnDataType.Text,
    filterName: 'filterMarket',
  },

  {
    fieldName: 'submarket',
    displayColumn: 'Sub Market',
    dataTypeColumn: ColumnDataType.Text,
    filterName: 'filterSubmarket',
  },
  {
    fieldName: 'custom',
    displayColumn: '',
    dataTypeColumn: ColumnDataType.Custom,
    stickyEnd: true,
    filterName: 'customFilter',
  },
];

export const MARKET_ERROR_MSG = 'Market is required';
export const SUBMARKET_ERROR_MSG = 'Sub Market is required';
export const INDUSTRY_SEGMENT_ERROR_MSG = 'Industry Segment is required';

export type MessageType = {
  type: string;
  message: string;
};

export const VALIDATION_MSGS = {
  siteAttribute: [
    { type: 'required', message: 'Site Attribute is required field' },
    {
      type: 'invalidAutocompleteAttributeValue',
      message: 'Please Select Attribute from dropdown',
    },
  ],
  value: [
    { type: 'required', message: 'Attribute Value is required field' },
    { type: 'min', message: 'Attribute Value should be minimum' },
    { type: 'max', message: 'Attribute Value should be maximum' },
  ],
};

export const CSA_VALIDATION_MSGS = {
  siteAttribute: [
    { type: 'required', message: 'Site Attribute is required field' },
    {
      type: 'invalidAutocompleteAttributeValue',
      message: 'Please Select Attribute from dropdown',
    },
  ],
  attributeValue: [
    { type: 'required', message: 'Attribute Value is required field' },
    { type: 'min', message: 'Attribute Value should be minimum' },
    { type: 'max', message: 'Attribute Value should be maximum' },
    {
      type: 'invalidAutocompleteAttributeValue',
      message: 'Please Select Attribute from dropdown',
    },
  ],
};
export const MAX_15_DIGITS = {
  type: 'max',
  message: 'Maximum 15 digits allowed!',
};

export const MAX_DECIMAL = 999999999999999.99;

export const MAX_29_DIGIT = {
  type: 'maxDigits',
  message:
    'A maximum of 29 digits is allowed, including up to 15 decimal places.',
};

export const OPI_VALIDATION_MSGS = {
  offeringId: [
    { type: 'required', message: 'Offering Name is required field' },
  ],
  submarket: [{ type: 'required', message: 'SubMarket is required field' }],
  region: [{ type: 'required', message: 'Region is required field' }],
  scalingFactor: [
    { type: 'required', message: 'Scaling Factor is required field' },
    { type: 'min', message: 'Scaling Factor should be minimum' },
    MAX_15_DIGITS,
  ],
  consumption: [
    { type: 'required', message: 'Consumption is required field' },
    { type: 'min', message: 'Consumption should be minimum' },
    MAX_29_DIGIT,
  ],
  ecolabInvestment: [
    { type: 'required', message: 'Ecolab Investment is required field' },
    { type: 'min', message: 'Ecolab Investment should be minimum' },
    MAX_15_DIGITS,
  ],
  valueCategory: [
    { type: 'required', message: 'Value Category is required field' },
  ],
  value: [{ type: 'min', message: 'Value should be minimum' }, MAX_29_DIGIT],
  quantity: [
    { type: 'min', message: 'Quantity should be minimum' },
    MAX_29_DIGIT,
  ],
};

export const enum FormMode {
  ADD = 'Add',
  VIEW = 'View',
  DELETE = 'Delete',
  EDIT = 'EDIT',
}

export const enum SegmentHierarchy {
  INDUSTRY_SEGMENT = 'Industry Segment',
  MARKET = 'Market',
  SUBMARKET = 'Sub Market',
}

export const enum GeographyHierarchy {
  REGION = 'Region',
  COUNTRY = 'Country',
  STATE = 'State',
}

export enum BulkUploadStatus {
  PROCESSED = 'Processed',
  PROCESSED_WITH_ERRORS = 'Processed with Errors',
  DEADLETTERED = 'DeadLettered',
}

export const CustomersDefaultValue: ICustomers = {
  Id: 'All',
  Name: 'ALL',
};
export const GeographyDefaultValue: IRegion = {
  id: 'All',
  value: 'ALL',
};
export const SOStatusOptions = [
  {
    id: 'Active',
    value: 'Active',
  },
  {
    id: 'Inactive',
    value: 'Inactive',
  },
];

export const DUPLICATE_MSG =
  'This combination with (Segmentation, Customer, Geography) already exists.';
export const UNEXPECTED_ERROR = 'UNEXPECTED ERROR OCCURED';
export const SUCCESS_MSG = 'Row added successfully!';
export const UPDATE_SUCCESS_MSG = 'Row updated successfully';
export const INVALID_ID = 'No ID Exists';
export const ROW_DELETED_SUCCESS = 'Row was successfully deleted.';

export const POSITION_START = 'START';
export const POSITION_END = 'END';

export const CSA_HEADER = 'Edit Customer Site Profile';
export const SO_HEADER = 'Edit Customer Site Offerings';

export const OFFERING_DETAILS_EDIT_HEADER = 'Edit BIC Offering Details';
export const PRODUCT_DETAILS_EDIT_HEADER = 'Edit BIC Product Details';
export const OFFERING_DETAILS_ADD_HEADER = 'Add BIC Offering Details';
export const PRODUCT_DETAILS_ADD_HEADER = 'Add BIC Product Details';

export const OFFERING_DETAILS = 'OD';
export const CUSTOMER_SITE_PROFILE = 'CSP';
export const DEFAULT_SITE_PROFILE = 'DSP';

export const BASIC_INFO = [
  {
    label: 'Customer',
    value: 'MARRIOT',
  },
  {
    label: 'Ecolab Site ID',
    value: '1234567',
  },
  {
    label: 'Customer Site ID',
    value: 'FSU456',
  },
  {
    label: 'Site Address',
    value: '123 Maple Street, Springfield, IL 62701',
  },
  {
    label: 'Country',
    value: 'USA',
  },
  {
    label: 'Site Description',
    value: 'MRT Site FSU456',
  },
];

export const UNEXPECTED_ERROR_MESSAGE =
  'Something went wrong, please reload the page.';

export const BAD_REQUEST_MESSAGE =
  'Sorry something went wrong. One or more input request is invalid.';

export const CHOOSE_FILE = 'Choose a file';
export const UPLOAD = 'Upload';
export const SELECTED_FILE_TEXT = 'Selected File is:';
export const INVALID_FILE_FORMAT =
  'Invalid File Format! Please upload .xlsx or .xls file';
export const UPLOAD_TEXT = 'Upload .xlsx or .xls file';

export const OFFERING_POTENTIAL_INVESTMENT_TABLE_MAPPER: ITableMatcher[] = [
  {
    fieldName: 'offeringName',
    displayColumn: 'Offering Name',
    dataTypeColumn: ColumnDataType.Text,
    filterName: 'filterOfferingName',
  },
  {
    fieldName: 'submarket',
    displayColumn: 'Sub Market',
    dataTypeColumn: ColumnDataType.Text,
    filterName: 'filterSubmarket',
  },
  {
    fieldName: 'region',
    displayColumn: 'Region',
    dataTypeColumn: ColumnDataType.Text,
    filterName: 'filterRegion',
  },
  {
    fieldName: 'customer',
    displayColumn: 'Customer',
    dataTypeColumn: ColumnDataType.Text,
    filterName: 'filterCustomer',
  },
  {
    fieldName: 'ecolabSiteId',
    displayColumn: 'Ecolab Site ID',
    dataTypeColumn: ColumnDataType.Text,
    filterName: 'filterEcolabSiteId',
  },
  {
    fieldName: 'custom',
    displayColumn: '',
    dataTypeColumn: ColumnDataType.Custom,
    filterName: 'customFilter',
  },
];

export const BULK_UPLOAD = 'Bulk Upload';
export const BULK_UPLOAD_UNEXPECTED_ERROR_MESSAGE =
  'Something went wrong, please try again.';

export const LOADER_TEXT = 'Please wait while your file is being uploaded...';
export const FILE_SIZE_EXCEEDED =
  'File Size Exceeded. Please select file with size less than 5MB';
export const DOWNLOAD_HERE = 'Download Here';
export const ERROR_MORE_INFO_TEXT =
  'Please view the following for more information of bulk upload status';
export const LOOK_MORE_INFO = 'Looking for more information?';
export const UPLOAD_PROCESSED_SUCCESS_MSG =
  'Your upload has been processed Successfully!';
export const UPLOAD_PROCESSED_PARTIAL_MSG =
  'Your upload has been processed Partially with Errors!';
export const SUCCESS = 'Success';
export const ERROR = 'Error';
export const BULK_UPLOAD_FAILED_MSG =
  'Your upload request has failed. Here is your request id {0}';
export const BULK_UPLOAD_TIMED_OUT_MSG =
  'Your upload request has timed out. Here is your request id {0}';
export const OFFERING_ERROR_MESSAGE =
  'Download the file to review all the results. Please correct the issues and re-upload to ensure all records are updated.';

export const DEFAULT_CARD_CURRENCY = 'USD';

export const DSP_VALIDATION_MSGS = {
  industrySegment: [
    { type: 'required', message: 'industrySegment is required field' },
  ],
  market: [{ type: 'required', message: 'Market is required field' }],
  submarket: [{ type: 'required', message: 'SubMarket is required field' }],
};

export const ASSETTYPE = 'Assettype';

export enum UserPermission {
  READ_ALL = 'READALL',
  EDIT_ALL = 'EDITALL',
  BIC_ADMIN = 'BICADMIN',
}

export const RETURN_TO_ECOLAB = `${environment.ECOLAB_WEB}`;

export const CUSTOMER_SITE_MANAGER_MAPPER: ITableMatcher[] = [
  {
    fieldName: 'customer',
    displayColumn: 'Customer',
    dataTypeColumn: ColumnDataType.Text,
    sticky: true,
    filterName: 'filterCustomer',
  },
  {
    fieldName: 'ecolabSiteId',
    displayColumn: 'Ecolab Site ID',
    dataTypeColumn: ColumnDataType.Text,
    sticky: true,
    filterName: 'filterEcolabSiteId',
  },
  {
    fieldName: 'customerPropertyCd',
    displayColumn: 'Customer Site ID',
    dataTypeColumn: ColumnDataType.Text,
    filterName: 'filterCustomerPropertyCd',
  },
  {
    fieldName: 'siteAddress',
    displayColumn: 'Site Address',
    dataTypeColumn: ColumnDataType.Text,
    filterName: 'filterSiteAddress',
  },
  {
    fieldName: 'country',
    displayColumn: 'Country',
    dataTypeColumn: ColumnDataType.Text,
    filterName: 'filterCountry',
  },
  {
    fieldName: 'siteDescription',
    displayColumn: 'Site Description',
    dataTypeColumn: ColumnDataType.Text,
    filterName: 'filterSiteDescription',
  },
  {
    fieldName: 'industrySegment',
    displayColumn: 'Industry Segment',
    dataTypeColumn: ColumnDataType.Text,
    filterName: 'filterIndustrySegment',
  },
  {
    fieldName: 'market',
    displayColumn: 'Market',
    dataTypeColumn: ColumnDataType.Text,
    filterName: 'filterMarket',
  },
  {
    fieldName: 'submarket',
    displayColumn: 'Sub Market',
    dataTypeColumn: ColumnDataType.Text,
    filterName: 'filterSubmarket',
  },
  {
    fieldName: 'siteStatus',
    displayColumn: 'Site Status',
    dataTypeColumn: ColumnDataType.Text,
    filterName: 'filterSitestatus',
  },
  {
    fieldName: 'isBicPreferredSite',
    displayColumn: 'Included in BIC',
    dataTypeColumn: ColumnDataType.Custom,
    stickyEnd: true,
    filterName: 'customFilter',
    sort: true,
  },
];

export const DORMANT = 'DORMANT';
